import { useEffect, useRef, useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";
import { focusRing } from "components/ui/instrument";

interface SnoozeOption {
  value: string;
  label: string;
}

interface SnoozeDropdownProps {
  selectedValue: string;
  onChange: (value: string) => void;
  options: SnoozeOption[];
}

function SnoozeDropdown({
  selectedValue,
  onChange,
  options,
}: SnoozeDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Handle click outside of the dropdown to close it
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOptionClick = (option: SnoozeOption) => {
    if (option.value === "custom" || option.value !== selectedValue) {
      onChange(option.value);
      setIsOpen(false);
    }
  };

  return (
    <div
      ref={dropdownRef}
      style={{ position: "relative", display: "inline-block" }}
    >
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`mx-auto flex w-40 cursor-pointer items-center justify-between rounded-md bg-white p-2 text-sm text-clinic-700 ring-1 ring-clinic-300 hover:bg-clinic-50 ${focusRing}`}
      >
        {options.find((opt) => opt.value === selectedValue)?.label ||
          "Select duration"}
        {isOpen ? (
          <FaChevronUp className="shrink-0 text-[12px] text-clinic-500" />
        ) : (
          <FaChevronDown className="shrink-0 text-[12px] text-clinic-500" />
        )}
      </button>
      {isOpen && (
        <div
          className={`absolute top-full right-0 z-50 mt-1 min-w-[250px]  overflow-hidden rounded-md border border-clinic-200 bg-white shadow-md`}
        >
          {options.map((option, index) => (
            <div
              key={index}
              style={{
                cursor:
                  option.value === "custom" || option.value !== selectedValue
                    ? "pointer"
                    : "not-allowed",
              }}
              className={`py-2 px-3 text-sm text-clinic-700 ${
                option.value !== selectedValue || option.value === "custom"
                  ? "hover:bg-clinic-50"
                  : ""
              }`}
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SnoozeDropdown;
